export default "__VITE_ASSET__e1f3bb4d__"